// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"yl_a"};